import { Trash } from '@/resources/assets/images';
import { Dialog } from '@/components/atoms/Dialog';
import Button from '@/components/Button/newButtons';
import type { DashboardDeleteBusinessDataProps } from '@/modules/dashboard/dashboardActions';

export type RemoveContactDataModalProps = DashboardDeleteBusinessDataProps & {
	isOpen: boolean;
	onCloseModal: VoidFunction;
	onRemoveContactData: (props: DashboardDeleteBusinessDataProps) => void;
};

export const RemoveContactDataModal = ({
	businessId,
	userEmail,
	listId,
	dataInd,
	isOpen,
	onCloseModal,
	onRemoveContactData
}: RemoveContactDataModalProps) => {
	const handleRemoveContactData = () => {
		if (!businessId) return null;

		onRemoveContactData({
			businessId,
			userEmail,
			listId,
			dataInd
		});
	};

	return (
		<Dialog.Root open={isOpen} onOpenChange={onCloseModal}>
			<Dialog.Content className="gap-8 border-none">
				<Dialog.Title>Are you sure?</Dialog.Title>

				<Dialog.Description>
					Contact data will be permanently removed from this
					bussiness.
				</Dialog.Description>

				<Dialog.Footer>
					<Dialog.Close asChild>
						<Button variant="text">Cancel</Button>
					</Dialog.Close>

					<Dialog.Close asChild>
						<Button
							variant="secondary"
							onClick={handleRemoveContactData}
							red
							leftIcon={<Trash />}
						>
							Confirm Deletion
						</Button>
					</Dialog.Close>
				</Dialog.Footer>
			</Dialog.Content>
		</Dialog.Root>
	);
};
